import { useMutation } from '@tanstack/react-query';

import { toggleLockBilling } from '../api/ToggleLockBilling';

interface Props {
  onSuccess: () => void;
  onError: () => void;
}

export const useToggleLockBilling = ({ onSuccess, onError }: Props) => {
  const { mutate } = useMutation({
    mutationFn: (billingUuid: string) => toggleLockBilling(billingUuid),
    onSuccess: () => {
      onSuccess();
    },
    onError,
  });

  return { toggleLockBilling: mutate };
};
